import { Outlet } from "react-router-dom";

const MainOtherExpenses = () => {
    return(
        <div className="w-full h-full">
            <Outlet/>
        </div>
    )
}
export default MainOtherExpenses;